module.exports = __webpack_public_path__ + "static/media/ECUST_LOGO.405e11b8.png";